import { Theme } from '@mui/material';
import { InvoiceStatus } from '@prisma/client';

function selfBillingInvoiceBannerConfigs(invoiceStatus: InvoiceStatus, theme: Theme) {
    switch (invoiceStatus) {
        case InvoiceStatus.PROCESSING: {
            return {
                title: 'This Invoice is still processing',
                subText: 'Please wait for the processing to be completed',
                styles: {
                    bgColor: theme.palette.background.info,
                    borderStyle: theme.palette.border.info,
                },
            };
        }
        case InvoiceStatus?.FAILED: {
            return {
                title: 'This invoice failed to process',
                subText: `Please fix the failure reason before clicking 'Resubmit to Sage'`,
                styles: {
                    bgColor: theme.palette.background.error,
                    borderStyle: theme.palette.border.warn,
                },
            };
        }
        case InvoiceStatus?.PARTIALLY_FAILED: {
            return {
                title: 'This invoice has partially failed to be processed',
                subText: `Please fix the failure reason before clicking 'Release Invoice'`,
                styles: {
                    bgColor: theme.palette.background.warn,
                    borderStyle: theme.palette.border.error,
                },
            };
        }
        default: {
            return null;
        }
    }
}

export default selfBillingInvoiceBannerConfigs;
